import { useState, useMemo } from "react";
import { LicenseManager } from "ag-charts-enterprise";
import {
    AGGRID_LICENCE_KEY,
    Utils,
} from "../../../../../shared";
import "ag-charts-community";
import "ag-charts-enterprise";
import { AgCharts } from "ag-charts-react";

LicenseManager.setLicenseKey(AGGRID_LICENCE_KEY);

const OrderProgressCard = ({ plannedAmount = 0, orderedAmount = 0, digitalBudget = 0 }) => {
    const [shouldIncludeNonDigital] = useState(false);

    const progressPercentage = useMemo(() => {
        const planned = plannedAmount + (shouldIncludeNonDigital ? digitalBudget : 0);
        return planned && planned > 0
            ? (orderedAmount / planned) * 100
            : 0;
    }, [plannedAmount, orderedAmount, digitalBudget, shouldIncludeNonDigital]);

    const chartOptions = useMemo(
        () => ({
            data: [
                {
                    plannedAmount: plannedAmount + (shouldIncludeNonDigital ? digitalBudget : 0),
                    category: "Planned",
                },
                {
                    orderedAmount,
                    category: "Ordered",
                }
            ],
            series: [
                {
                    type: "bar",
                    xKey: "category",
                    yKey: 'plannedAmount',
                    fill: "#EBF1F6",
                    stroke: "#EBF1F6",
                    cornerRadius: 5,
                    showInLegend: true,
                    xNamed: "Planned",
                    yName: 'Planned',
                    legendItemName: 'Planned',
                },
                {
                    type: "bar",
                    xKey: "category",
                    yKey: 'orderedAmount',
                    fill: "#21EB7F",
                    stroke: "#21EB7F",
                    cornerRadius: 5,
                    showInLegend: true,
                    xNamed: "Ordered",
                    yName: 'Ordered',
                    legendItemName: 'Ordered',
                    tooltip: {
                        enabled: true,
                        renderer: (data) => data.datum.category === 'Planned' ? `&nbsp;&nbsp;Total planned: <b>${Utils.formatNumberToUSDCurrency(plannedAmount + (shouldIncludeNonDigital ? digitalBudget : 0))}</b>&nbsp;&nbsp;<br /><br />&nbsp;&nbsp;(Prisma ${Utils.formatNumberToUSDCurrency(plannedAmount + (shouldIncludeNonDigital ? digitalBudget : 0))})&nbsp;&nbsp;<br /><br />` : `&nbsp;&nbsp;Total ordered: <b>${Utils.formatNumberToUSDCurrency(orderedAmount)}</b>&nbsp;&nbsp;<br /><br />&nbsp;&nbsp;Budget remaining: ${Utils.formatNumberToUSDCurrency(plannedAmount + (shouldIncludeNonDigital ? digitalBudget : 0) - orderedAmount)}&nbsp;&nbsp;<br /><br />`
                    }
                },
            ],
            tooltip: {
                enabled: true,
                renderer: (data) => `Hello`
            },
            axes: [
                {
                    type: "category",
                    position: "bottom",
                    line: {
                        enabled: true
                    },
                    gridLine: {
                        style: [{ stroke: 'transparent' }]
                    },
                    legend: {
                        enabled: false,
                    },
                    label: {
                        rotation: -30,
                    }
                },
                {
                    type: "number",
                    position: "left",
                    line: {
                        enabled: true
                    },
                    label: {
                        enabled: false,
                    },
                    gridLine: {
                        style: [{ stroke: 'transparent' }]
                    },
                    legend: {
                        enabled: false,
                    }
                },
                
            ],
            legend: {
                enabled: false,
            }
        }),
        [plannedAmount, orderedAmount, shouldIncludeNonDigital, digitalBudget]
    );

    return (
        <div className="order-progress-card">
            <div className="card-content">
                <div className="left-content">
                    <div className="progress-header">
                        <h4 className="progress-title">Order Progress</h4>
                    </div>

                    <div className="progress-percentage">
                        <div className="percentage-value">{progressPercentage.toFixed(0)}%</div>
                        <div className="percentage-label">
                            ${(orderedAmount || 0).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                            })} / ${(plannedAmount || 0).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                            })}
                        </div>
                    </div>
                    {/* <div className="checkbox-container">
                        <input
                            type="checkbox"
                            id="includeNonDigital"
                            checked={shouldIncludeNonDigital}
                            onChange={() =>
                                setShouldIncludeNonDigital(
                                    (prev) => !prev
                                )
                            }
                        />
                        <label htmlFor="includeNonDigital">Include non-digital</label>
                    </div> */}
                </div>

                <div className="right-content">
                    <div className="chart-container">
                        <AgCharts options={chartOptions} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderProgressCard;
